import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

const Loading = ({
  size = 50,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <div
      data-testid="loading-spinner"
      className={cn(
        "flex h-full w-full items-center justify-center text-white",
        className
      )}
    >
      <Loader2 className="animate-spin" size={size} />
    </div>
  );
};

export default Loading;
